export default "__VITE_ASSET__acb2809d__"